import LocationButton from './locationButton';

export default LocationButton;
